export default __webpack_public_path__ + "static/media/twitter-2.da62acfa.svg";